import { FaTrash } from 'react-icons/fa';
import { SectionContent } from '@/contexts/ContentContext';

interface ServicesFormProps {
  content: SectionContent;
  onChange: (field: string, value: any) => void;
  onArrayItemChange: (arrayField: string, index: number, field: string, value: any) => void;
  onAddItem: (arrayField: string, defaultValue: any) => void;
  onRemoveItem: (arrayField: string, index: number) => void;
}

const defaultService = {
  icon: 'FaTools',
  title: 'Novo Serviço',
  description: 'Descrição do serviço',
};

export function ServicesForm({
  content,
  onChange,
  onArrayItemChange,
  onAddItem,
  onRemoveItem,
}: ServicesFormProps) {
  const services = content.services || [];

  return (
    <div className="space-y-6">
      <div className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Título da Seção
          </label>
          <input
            type="text"
            value={content.title || ''}
            onChange={(e) => onChange('title', e.target.value)}
            className="w-full p-2 border rounded-md focus:ring-primary-500 focus:border-primary-500"
          />
        </div>
        
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Subtítulo
          </label>
          <input
            type="text"
            value={content.subtitle || ''}
            onChange={(e) => onChange('subtitle', e.target.value)}
            className="w-full p-2 border rounded-md focus:ring-primary-500 focus:border-primary-500"
          />
        </div>
        
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Descrição
          </label>
          <textarea
            rows={2}
            value={content.description || ''}
            onChange={(e) => onChange('description', e.target.value)}
            className="w-full p-2 border rounded-md focus:ring-primary-500 focus:border-primary-500"
          />
        </div>
      </div>
      
      <div>
        <div className="flex justify-between items-center mb-2">
          <h4 className="text-sm font-medium text-gray-700">Serviços</h4>
          <button
            type="button"
            onClick={() => onAddItem('services', defaultService)}
            className="inline-flex items-center px-2.5 py-1.5 border border-transparent text-xs font-medium rounded text-primary-700 bg-primary-100 hover:bg-primary-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500"
          >
            <span className="mr-1">+</span> Adicionar Serviço
          </button>
        </div>
        
        <div className="space-y-4">
          {services.map((service, index) => (
            <div key={index} className="border p-4 rounded-lg">
              <div className="flex justify-between items-center mb-3">
                <h5 className="font-medium">Serviço {index + 1}</h5>
                <button
                  type="button"
                  onClick={() => onRemoveItem('services', index)}
                  className="text-red-600 hover:text-red-800"
                >
                  <FaTrash className="h-4 w-4" />
                </button>
              </div>
              
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-xs font-medium text-gray-500 mb-1">
                    Ícone
                  </label>
                  <select
                    value={service.icon || 'FaTools'}
                    onChange={(e) => onArrayItemChange('services', index, 'icon', e.target.value)}
                    className="w-full p-2 border rounded-md text-sm focus:ring-primary-500 focus:border-primary-500"
                  >
                    <option value="FaTools">Ferramentas</option>
                    <option value="FaHammer">Martelo</option>
                    <option value="FaWrench">Chave Inglesa</option>
                    <option value="FaScrewdriver">Chave de Fenda</option>
                    <option value="FaRuler">Régua</option>
                  </select>
                </div>
                
                <div>
                  <label className="block text-xs font-medium text-gray-500 mb-1">
                    Título
                  </label>
                  <input
                    type="text"
                    value={service.title || ''}
                    onChange={(e) => onArrayItemChange('services', index, 'title', e.target.value)}
                    className="w-full p-2 border rounded-md text-sm focus:ring-primary-500 focus:border-primary-500"
                  />
                </div>
                
                <div className="md:col-span-2">
                  <label className="block text-xs font-medium text-gray-500 mb-1">
                    Descrição
                  </label>
                  <textarea
                    rows={2}
                    value={service.description || ''}
                    onChange={(e) => onArrayItemChange('services', index, 'description', e.target.value)}
                    className="w-full p-2 border rounded-md text-sm focus:ring-primary-500 focus:border-primary-500"
                  />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
